import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import utils from "../../components/toastify/toastify";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";

const ShowSubCategories = (props) => {
  const [
    delete_sub_category_by_id_error,
    delete_sub_category_by_id_loading,
    delete_sub_category_by_id_data,
    delete_sub_category_by_id_function,
  ] = useRequest({
    method: "post",
    isFunction: true,
    url: "/delete_sub_category_by_id",
  });
  const [
    get_sub_categories_error,
    get_sub_categories_loading,
    get_sub_categories_data,
    get_sub_categories_function,
    clearData,
  ] = useRequest({
    method: "get",
    url: "/get_sub_categories",
  });

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        {/* <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div> */}
        {get_sub_categories_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">عنوان</th>

                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              get_sub_categories_data.data.map((item) => (
                <tr>
                  <td>{item.title}</td>
                  <td>
                    <Link to={"/dashboard/editSubCategory/" + item._id}>
                      <button
                        type="button"
                        className="btn btn-primary round mr-1 mb-1 btn-sm"
                      >
                        ویرایش
                      </button>
                    </Link>

                    <button
                      onClick={async () => {
                        await clearData();
                        await delete_sub_category_by_id_function({
                          sub_category_id: item._id,
                        })
                          .then(() => {
                            utils.showAlert("با موفقیت حذف شد", "success");
                            get_sub_categories_function();
                          })
                          .catch(() => {
                            utils.showAlert("حذف نشد", "error");
                            get_sub_categories_function();
                          });
                      }}
                      type="button"
                      className="btn btn-danger round mr-1 mb-1 btn-sm"
                    >
                      حذف
                    </button>
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { ShowSubCategories };
